"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assign = _interopRequireDefault(require("lodash/assign"));
var _transform = _interopRequireDefault(require("lodash/transform"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var choiceChangedSuccess = function choiceChangedSuccess(state, _ref) {
  var choiceId = _ref.choiceId,
    choiceValue = _ref.choiceValue,
    siblingIds = _ref.siblingIds,
    settingDefaultsOnChange = _ref.settingDefaultsOnChange;
  var choice = state[choiceId];
  var updatedChoice = _objectSpread({}, choice);
  if (choice.isSelected && choice.value === choiceValue && !settingDefaultsOnChange) {
    (0, _assign["default"])(updatedChoice, {
      isSelected: false
    });
  } else {
    // setting defaults on some property change
    (0, _assign["default"])(updatedChoice, {
      isSelected: true,
      value: choiceValue
    });
  }
  var siblings = (0, _transform["default"])(siblingIds, function (obj, sid) {
    return obj[sid] = _objectSpread(_objectSpread({}, state[sid]), {}, {
      isSelected: false
    });
  });
  return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2["default"])({}, choiceId, updatedChoice), siblings);
};
var _default = exports["default"] = choiceChangedSuccess;
//# sourceMappingURL=choiceChangedSuccess.js.map